import { PinInput as PinInput_ } from "@chakra-ui/react";
import { forwardRef } from "react";
export const PinInput = forwardRef(({ ...props }, ref) => {
    return <PinInput_ ref={ref} {...props}>{props?.children}</PinInput_>
});

import { PinInputField as PinInputField_ } from "@chakra-ui/react";
export const PinInputField = forwardRef(({ ...props }, ref) => {
    return <PinInputField_ ref={ref} {...props}>{props?.children}</PinInputField_>
});